import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import BaseCadastro from "components/BaseCadastro";
import { Label } from "components/input/Label";
import GrupoUsuarios from "model/administracao/cadastro/GrupoUsuarios";
import GrupoUsuariosUsuario from "model/administracao/cadastro/GrupoUsuariosUsuario";
import Usuario from "model/administracao/cadastro/Usuario";
import { Button } from "primereact/button";
import { Column, ColumnBodyOptions } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import GrupoUsuariosService from "service/administracao/cadastro/GrupoUsuariosService";

const grupoUsuariosService = new GrupoUsuariosService();

export default function GrupoUsuariosCadastro() {

    const { setError, formState: { errors }, register, clearErrors } = useForm();

    const [usuarios, setUsuarios] = useState<Usuario[]>([]);
    const titulo = "Cadastro de Grupo de usuários";

    const [grupoUsuarios, setGrupoUsuarios] = useState<GrupoUsuarios>(new GrupoUsuarios());

    useEffect(() => {
        grupoUsuariosService.usuarios().then(resposta => {
            setUsuarios([new Usuario(-1, null, 'Selecione'), ...resposta])
        })
    }, [])

    useEffect(() => {
        console.log(grupoUsuarios.itens)
    }, [grupoUsuarios])
    function validar() {

        if (!grupoUsuarios.nome) {
            setError("nome", { type: "manual", message: "Nome é obrigatório" }, { shouldFocus: true })
            return false;
        }

        return true;
    }

    const editorUsuario = (rowData: GrupoUsuariosUsuario, rowIndex: number) => {
        return <Dropdown
            className="col col-sm-12"
            options={usuarios}
            filter
            dataKey="id"
            optionLabel="nome"
            valueTemplate={(option: Usuario) => option ? option.nome : "Selecione"}
            value={rowData.usuario || usuarios[0]}
            style={{ width: '100%' }}
            onChange={(e) => {
                if (e.value.id === -1) {
                    grupoUsuarios.itens[rowIndex].usuario = null;
                    rowData.usuario = null;
                }
                else {
                    grupoUsuarios.itens[rowIndex].usuario = e.value as Usuario;
                    rowData.usuario = e.value as Usuario;
                }
                setGrupoUsuarios({ ...grupoUsuarios })
            }}
        />
    }

    return (

        <BaseCadastro model={grupoUsuarios} service={grupoUsuariosService} setModel={(value: GrupoUsuarios) => setGrupoUsuarios(value)} validar={() => validar()} urlService="/grupoUsuarios" pathCadastro="/grupoUsuarios" tituloPagina={titulo}>

            {titulo ?
                <div className="row">
                    <label style={{ fontSize: 18, fontWeight: 'bold' }} className="col col-sm-12">{titulo}</label>
                </div>
                : null}


            <div className="row">
                <Label className="col col-sm-12" obrigatorio>Nome</Label>
                <div className="col-sm-12">
                    <InputText required value={grupoUsuarios.nome} style={{ width: '100%' }}
                        className={errors.nome ? "p-invalid" : ""}
                        {...register("nome", {
                            onChange: (e) => {
                                clearErrors("nome");
                                setGrupoUsuarios({ ...grupoUsuarios, nome: e.target.value })
                            }
                        })}
                    />
                </div>
                {errors.nome && errors.nome.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.nome?.message as string}</span> : null}
            </div>

            <div className="row">
                <div className="col-sm-12">
                    <DataTable value={grupoUsuarios.itens} scrollable scrollHeight='500px'
                        emptyMessage="Nenhum registro encontrado"
                        header={<div style={{ display: "flex", justifyContent: "space-between", textAlign: 'center', alignContent: "center" }}>
                            <div></div>
                            <span style={{ textAlign: 'center', alignSelf: "center", position: 'relative' }}>Usuários</span>
                            <div>
                                <Button
                                    type="button" icon={<FontAwesomeIcon icon="add" />}
                                    tooltip="Adicionar"
                                    tooltipOptions={{ position: "top" }} className="ui-button-info" onClick={() => setGrupoUsuarios({ ...grupoUsuarios, itens: [...(grupoUsuarios.itens || []), new GrupoUsuariosUsuario()] })}
                                ></Button>
                            </div>
                        </div>}
                    >
                        <Column
                            field="usuario" header="Usuário"
                            body={(rowData: GrupoUsuariosUsuario, options: ColumnBodyOptions) => editorUsuario(rowData, options.rowIndex)}
                        />
                        <Column style={{ width: "50px" }} body={(rowData: GrupoUsuariosUsuario, options: ColumnBodyOptions) => {
                            return <Button
                                type="button" icon={<FontAwesomeIcon icon="trash" />}
                                tooltip="Remover"
                                tooltipOptions={{ position: "top" }} className="ui-button-danger"
                                onClick={() => {
                                    grupoUsuarios.itens.splice(options.rowIndex, 1);
                                    setGrupoUsuarios({ ...grupoUsuarios });
                                }}
                            />
                        }}
                        />
                    </DataTable>
                </div>
            </div>
        </BaseCadastro>
    )
}
